import { createRoutine, bindRoutineToReduxForm } from "redux-saga-routines";

export const setPageTitleRoutine = createRoutine("common/SET_PAGE_TITLE");
